export const NAV = [
  { key: "work", href: "#work" },
  { key: "demos", href: "#portfolio" },
  { key: "studio", href: "#about" },
  { key: "contact", href: "#contact" },
];

// Manifesto numbers only — titles/bodies come from i18n (t.about.chapters)
export const MANIFESTO_NUMBERS = ["01", "02", "03"];

// Structural project data — text (tag/description) comes from i18n (t.work)
export const PROJECT = {
  id: "auto-shine-pro-32",
  title: "Auto Shine Pro 32",
  brand: "Apex Detailing",
  year: "2025",
  cover:
    "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  gallery: [
    "https://images.unsplash.com/photo-1620584899131-a5ff5f8fbb03?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.pexels.com/photos/6873190/pexels-photo-6873190.jpeg?auto=compress&cs=tinysrgb&w=1000",
  ],
};

// Structural demo data — text (tag/blurb) comes from i18n (t.portfolio)
export const DEMOS = [
  {
    id: "auto-shine-pro-32",
    name: "Apex Auto Detailing",
    url: "https://auto-shine-pro-32.preview.emergentagent.com/?utm_source=share",
    image: "/portfolio/auto-shine-pro-32.png",
  },
  {
    id: "brew-hub-518",
    name: "Ember Coffee",
    url: "https://brew-hub-518.preview.emergentagent.com/?utm_source=share",
    image: "/portfolio/brew-hub-518.png",
  },
];

export const PHONE = { display: "0439 384 875", href: "tel:0439384875" };
